import { Box } from 'braid-design-system';
import type { FC, ReactElement } from 'react';

import { Modal, type ModalProps } from 'src/libs/Modal';

import * as styles from './ImageModal.css';

export interface ImageModalProps
  extends Pick<ModalProps, 'close' | 'isOpen' | 'titleId'> {
  children: ReactElement;
  image: ReactElement;
}

export const ImageModal: FC<ImageModalProps> = ({
  children,
  close,
  image,
  isOpen,
  titleId,
}) => (
  <Modal isOpen={isOpen} titleId={titleId} close={close}>
    <Box className={styles.container}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={styles.imageContainer}
      >
        {image}
      </Box>
      <Box
        paddingX={['medium', 'large']}
        paddingY={['medium', 'xlarge']}
        className={styles.contentContainer}
      >
        {children}
      </Box>
    </Box>
  </Modal>
);
